import React, { useCallback, useEffect, useState } from 'react'

import SectionLayout from '../../components/reusable/SectionLayout'
import fetchFarmerFarmList from '../../apis/fetchFarmerFarmList'
import { Farm } from '../../models/farmer'

import FarmReportCard from './FarmReportCard'
import EmptySectionCard from '../reusable/EmtySectionCard'

interface Props {
  farmerId: string
  highlight: boolean
}

const FarmReportsSection = ({ farmerId, highlight }: Props) => {
  const [farms, setFarms] = useState<Farm[]>([])

  const fetchAndUpdateFarmList = useCallback(async () => {
    const result = await fetchFarmerFarmList(farmerId)
    if (result) setFarms(result)
  }, [farmerId])

  useEffect(() => {
    fetchAndUpdateFarmList()
  }, [fetchAndUpdateFarmList])

  return (
    <SectionLayout
      title="Farms"
      description="Farmer’s farms which are tagged with farm location"
      highlight={highlight}
    >
      {farms.map((farm, index) => (
        <FarmReportCard
          farmIndex={index}
          key={farm.id}
          farmImage={farm.photo}
          farmName={farm.name}
          land={
            farm.area_by_shape_file
              ? `${farm.area_by_shape_file} ${farm.area_by_shape_file_land_unit}`
              : ''
          }
          latLng={farm.lat_lng}
          reportUrl={farm.farm_nerax_report}
          cropImage={farm.crop_image}
        />
      ))}
      {farms.length === 0 && <EmptySectionCard title={'No tagged farm'} />}
    </SectionLayout>
  )
}

export default FarmReportsSection
